document.addEventListener("DOMContentLoaded", function () {
  function registerViewportCssVars() {
    const scrollBarWidth = window.innerWidth - document.body.offsetWidth;
    const vh = window.innerHeight * 0.01;
    const vw = window.innerWidth * 0.01;
    const svw = document.body.offsetWidth * 0.01;

    let svh;
    if (window.innerWidth < document.body.scrollWidth) {
      svh = vh - scrollBarWidth / 100;
    } else {
      svh = vh;
    }

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--svh", `${svh}px`);
    document.documentElement.style.setProperty("--svw", `${svw}px`);
    document.documentElement.style.setProperty(
      "--wpct-scrollbar-width",
      `${scrollBarWidth}px`
    );
  }

  let timeout;
  window.addEventListener("resize", function () {
    clearTimeout(timeout);
    timeout = setTimeout(registerViewportCssVars, 100);
  });

  registerViewportCssVars();
  registerViewportCssVars();
});
